import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import { Button, Dialog, DialogActions, DialogTitle, TextField } from '@mui/material';
import React from 'react';
import { DateInput, EventClickArg } from '@fullcalendar/core';
import { useTranslation,  } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// interface ITrackdaysCalendarControlProps extends WithTranslation, RouteComponentProps {
//     eventsFeed: string;
// }

interface ITrackdaysCalendarControlProps {
    eventsFeed: string;
}

export default function TrackdaysCalendarControl(props: ITrackdaysCalendarControlProps){
    const [openDatePicker, setOpenDatePicker] = React.useState(false);
    const [selectedDate, setSelectedDate] = React.useState<DateInput>(new Date());
    const navigate = useNavigate();
    const { t, i18n  } = useTranslation("common");
    const calendarRef = React.createRef<FullCalendar>();

    const handleCloseDialog = () => {
        setOpenDatePicker(false);
    }
    const handleOpenDialog = () => {
        setOpenDatePicker(true);
    }
    const handleGoToDate = () => {
        // @ts-ignore
        let calendarApi = calendarRef.current.getApi();
        calendarApi.gotoDate(selectedDate);
        setOpenDatePicker(false);
    }

    const handleGoToDateChange = (event: any) => {
        setSelectedDate(event.target.value);
    }

    const handleTrackdayClick = (args: EventClickArg) => {
                navigate(`/event/${args.event.id}`);
    }

    return (
        <React.Fragment>
            <Dialog onClose={handleCloseDialog} aria-labelledby="simple-dialog-title" open={openDatePicker}>
                <DialogTitle id="simple-dialog-title">{t("events.goToDate")}</DialogTitle>
                <TextField
                    id="gotodate"
                    label={t("events.selectDate")}
                    type="date"
                    onChange={handleGoToDateChange}
                    InputLabelProps={ {
                        shrink: true
                    } }
                />
                <DialogActions>
                    <Button onClick={handleCloseDialog}>{t("events.cancel")}</Button>
                    <Button onClick={handleGoToDate}>{t("events.go")}</Button>
                </DialogActions>
            </Dialog>
            <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView="dayGridMonth"
                events={props.eventsFeed}
                eventClick={handleTrackdayClick}
                headerToolbar={{
                    start: 'datePickerButton today',
                    center: 'title',
                    end: 'dayGridMonth,dayGridWeek,dayGridDay prev,next'
                }}
                // footerToolbar={{
                //     left: 'prev,next today',
                //     center: 'title',
                //     right: 'dayGridMonth,timeGridWeek,timeGridDay'
                // }}
                customButtons={{
                    datePickerButton: {
                        text: t<string>("calendar.selectDate"),
                        click: handleOpenDialog
                    }
                }}
                buttonText={{
                    today: t<string>("calendar.today"),
                    month: t<string>("calendar.month"),
                    week: t<string>("calendar.week"),
                    day: t<string>("calendar.day")
                }}
                navLinks={true}
                locale={i18n.language}
                firstDay={parseInt(t("calendar.firstDay"))}

                
            />
        </React.Fragment>
    );

}
